















































import OptionSelect from "../../core/Forms/OptionSelect.vue";
import { Intervention } from "../../models/Intervention";
import { RecurrenceIntervention } from "../../models/RecurrenceIntervention";
import InputField from "../../core/Forms/InputField.vue";
import FrequenceDaysSelection from "./FrequenceEditPartials/FrequenceDaysSelection.vue";
const Cleave = require("vue-cleave-component");

export default {
    name: "RecurrenceInterventionFrequenceEdit",
    components: { FrequenceDaysSelection, InputField, OptionSelect, Cleave },
    props: {
        value: RecurrenceIntervention.Frequence,
        recurrenceIntervention: RecurrenceIntervention,
    },
    data() {
        return {
            frequence: null,
            frequenceOptions: _.omit(
                Intervention.Frequence,
                Intervention.EFrequence.Ponctuel
            ),
            cleaveOptions: {
                date: true,
                datePattern: ["d", "m"],
                delimiter: "/",
            },
        };
    },
    created() {
        this.frequence = this.value;
    },
    methods: {
        deleteFrequence() {
            this.$emit("delete", this.frequence);
        },
    },
    watch: {
        frequence: {
            deep: true,
            immediate: true,
            handler: function () {
                if (this.frequence) {
                    this.$emit("input", this.frequence);
                }
            },
        },
    },
};
